import BaseService from './base.service'
import Store from '@/store/index'
import { getConfig, isStrEmpty } from '@/utils/utils'

const API_URL = process.env.VUE_APP_API_URL
const CURRENCY = Store.state?.configAccount?.settings?.CURRENCY ? Store.state?.configAccount?.settings?.CURRENCY : process.env.VUE_APP_CURRENCY_CODE
interface DrawsPayload {
    game: string,
}
interface GamePayload {
    currency: string,
}
class GamesService extends BaseService {
    getDrawGames(game) {
        const payload: DrawsPayload = {
            game: game
        }
        return this.post(API_URL + 'api/lotto/draws', payload).then((response) => {
            return response.data
        })
    }

    getListGame(){
        const payload: GamePayload = {
            currency: CURRENCY,
        }
        return this.post(API_URL + 'api/lotto/games', payload).then((response) => {
            if (response.data?.status === 'success') {
                localStorage.setItem('listGames', JSON.stringify(response.data?.data));
                Store.dispatch('handleConfig', !isStrEmpty(getConfig()) ? JSON.parse(getConfig()) : {})
            }
            return response.data
        })
    }

    setBlockGame(data){
        return this.post(API_URL + 'api/account/save-playblock-method', {
            playblock_method: data
        }).then((response) => {
            return response.data
        })
    }

}

export default new GamesService()
